/**
 * Change-history field names for common's notification rules by permission, the demo workspace
 * flag and the outbound webhooks subscriptions and settings (core PR 256).
 */
export const COMMON_CHANGE_EN = {
    'change.field.rule.recipient_permission': 'Recipients by permission',
    'change.field.rule.mandatory': 'Always sent',
    'change.field.rule.name_ar': 'Name in Arabic',
    'change.field.rule.name_en': 'Name in English',
    'change.field.rule.close_on': 'Closed by',
    'change.field.member_mute.user_id': 'Member',
    'change.field.member_mute.rule_key': 'Notice',
    'change.field.member_mute.channel': 'Channel',
    'change.field.workspace_flags.demo': 'Demo workspace',
    'change.field.workspace_flags.demo_since': 'Demo since',
    'change.field.workspace_flags.created_by': 'Set by',
    'change.field.webhook_settings.disable_after': 'Switch off after failures',
    'change.field.webhook_settings.created_by': 'Set by',
    'change.field.webhook_subscription.name': 'Name',
    'change.field.webhook_subscription.event_name': 'Event',
    'change.field.webhook_subscription.url': 'Address',
    'change.field.webhook_subscription.conditions': 'Conditions',
    'change.field.webhook_subscription.sealed_secret': 'Signing key',
    'change.field.webhook_subscription.status': 'Status',
    'change.field.webhook_subscription.disabled_reason': 'Reason switched off',
    'change.field.webhook_subscription.active_from': 'Active from',
    'change.field.webhook_subscription.retired_at': 'Ended on',
    'change.field.webhook_subscription.retired_by': 'Ended by',
    'change.field.webhook_subscription.created_by': 'Added by',
};
export const COMMON_CHANGE_AR = {
    'change.field.rule.recipient_permission': 'المستلمون حسب الصلاحية',
    'change.field.rule.mandatory': 'يُرسَل دائماً',
    'change.field.rule.name_ar': 'الاسم بالعربية',
    'change.field.rule.name_en': 'الاسم بالإنجليزية',
    'change.field.rule.close_on': 'يُغلقه',
    'change.field.member_mute.user_id': 'العضو',
    'change.field.member_mute.rule_key': 'التنبيه',
    'change.field.member_mute.channel': 'القناة',
    'change.field.workspace_flags.demo': 'منشأة تجريبية',
    'change.field.workspace_flags.demo_since': 'تجريبية منذ',
    'change.field.workspace_flags.created_by': 'ضبطها',
    'change.field.webhook_settings.disable_after': 'الإيقاف بعد عدد الإخفاقات',
    'change.field.webhook_settings.created_by': 'ضبطها',
    'change.field.webhook_subscription.name': 'الاسم',
    'change.field.webhook_subscription.event_name': 'الحدث',
    'change.field.webhook_subscription.url': 'العنوان',
    'change.field.webhook_subscription.conditions': 'الشروط',
    'change.field.webhook_subscription.sealed_secret': 'مفتاح التوقيع',
    'change.field.webhook_subscription.status': 'الحالة',
    'change.field.webhook_subscription.disabled_reason': 'سبب الإيقاف',
    'change.field.webhook_subscription.active_from': 'نشط منذ',
    'change.field.webhook_subscription.retired_at': 'أُنهي في',
    'change.field.webhook_subscription.retired_by': 'أنهاه',
    'change.field.webhook_subscription.created_by': 'أضافه',
};
//# sourceMappingURL=i18n-common-change.js.map